<template>
  <v-content>
    <v-container fluid grid-list-xl style="max-width: 91%">
      <div class="">
        <div class="d-flex-row">
          <div class="vidocontainer">
            <div class="card2">Remote User</div>
            <div
              id="remoteTrack"
              class="card-animate-2 card-animate-2-out"
              width="1920"
              height="1080"
            ></div>
          </div>

          <div class="vidocontainer">
            <div class="card2">Local User</div>
            <div
              id="localTrack"
              class="card-animate card-animate-out"
              width="1920"
              height="1080"
            ></div>
            <v-flex class="spaceVisual" />
            <!-- <Visualizer /> -->
            <v-flex class="spaceVisual" />
          </div>
        </div>

        <div class="">
          <div class="roomTitle">
            <span v-if="loading"> Loading... {{ roomName }}</span>
            <span v-else-if="!loading && roomName">
              Connected to {{ roomName }}</span
            >
            <span v-else>Select a room to get started</span>
          </div>
        </div>

        <div class="log" v-for="log in logs" v-bind:key="log.id">
          {{ log.message }}
        </div>
      </div>
    </v-container>
  </v-content>
</template>

<script>
// import { EventBus } from '../Event';
import Twilio, { createLocalVideoTrack } from 'twilio-video';
import axios from 'axios';
// import Visualizer from '../components/VisualizerDev.vue';

export default {
  name: 'Video',
  data() {
    return {
      speak: '',
      micOn: false,
      dialog: false,
      loading: false,
      data: {},
      localTrack: false,
      remoteTrack: '',
      activeRoom: '',
      previewTracks: '',
      identity: '',
      roomName: null,
      logs: [],
      logCount: 0,
      userInfo: {},
    };
  },
  components: {
    // Visualizer,
  },
  props: ['username'], // props that will be passed to this component
  mounted() {
    let profile = JSON.parse(localStorage.getItem('currentUser'));
    profile.name = profile.name.split(' ')[0].toLowerCase();
    this.userInfo = profile;
    console.log(profile);

    Event.$on('speakModeOn', (data) => {
      console.log(data);
      this.startSpeaking();
    });
  },
  beforeMount() {
    this.SpeechRecognition =
      window.SpeechRecognition || window.webkitSpeechRecognition;
    this.recognition = new window.webkitSpeechRecognition();
  },
  created() {
    //  this.createChat('Cogneetiv_Group'); // Hardcoded
    Event.$on('new_room', (room_name) => {
      this.createChat(room_name);
    });
  },
  methods: {
    async getAccessToken() {
      return await axios.get(
        `${process.env.VUE_APP_NODE_SERVER}/token?identity=${this.username}`
      );
    },
    // Trigger log events
    dispatchLog(message) {
      //  Event.$emit('new_log', message);
      this.logCount += 1;
      this.logs.push({ id: this.logCount, message: message });
    },
    // Attach the Tracks to the DOM.
    attachTracks(tracks, container) {
      console.log(tracks, container);
      tracks.forEach(function(track) {
        //    container.appendChild(track.attach());
        container.appendChild(track.attach());
      });
    },
    // Attach the Participant's Tracks to the DOM.
    attachParticipantTracks(participant, container) {
      let tracks = Array.from(participant.tracks.values());
      this.attachTracks(tracks, container);
    },
    // Detach the Tracks from the DOM.
    detachTracks(tracks) {
      tracks.forEach((track) => {
        track.detach().forEach((detachedElement) => {
          detachedElement.remove();
        });
      });
    },
    // Detach the Participant's Tracks from the DOM.
    detachParticipantTracks(participant) {
      let tracks = Array.from(participant.tracks.values());
      this.detachTracks(tracks);
    },
    // Leave Room.
    leaveRoomIfJoined() {
      if (this.activeRoom) {
        this.activeRoom.disconnect();
      }
    },
    createChat(room_name) {
      this.loading = true;
      const VueThis = this;

      this.getAccessToken().then((data) => {
        VueThis.roomName = null;
        const token = data.data.token;
        let connectOptions = {
          name: room_name,
          // logLevel: 'debug',
          audio: true,
          video: { width: 400 },
        };
        // before a user enters a new room,
        // disconnect the user from they joined already
        this.leaveRoomIfJoined();

        // remove any remote track when joining a new room
        document.getElementById('remoteTrack').innerHTML = '';

        Twilio.connect(token, connectOptions).then(function(room) {
          // console.log('Successfully joined a Room: ', room);
          VueThis.dispatchLog('Successfully joined a Room: ' + room_name);

          // set active toom
          VueThis.activeRoom = room;
          VueThis.roomName = room_name;
          VueThis.loading = false;

          // Attach the Tracks of the Room's Participants.
          room.participants.forEach(function(participant) {
            let previewContainer = document.getElementById('remoteTrack');
            VueThis.attachParticipantTracks(participant, previewContainer);
          });

          //    room.participants.forEach(function (participant) {
          //         console.log('Remote Participant connected: ', participant);

          //         participant.tracks.forEach(function (publication) {
          //             if (publication.isSubscribed) {
          //                 const track = publication.track;
          //                  let previewContainer = document.getElementById('remoteTrack');
          //                 previewContainer.appendChild(track.attach());
          //             }
          //         });
          //     });

          // When a Participant joins the Room, log the event.
          room.on('participantConnected', function(participant) {
            VueThis.dispatchLog("Joining: '" + participant.identity + "'");
          });

          // When a Participant adds a Track, attach it to the DOM.
          room.on('trackAdded', function(track, participant) {
            VueThis.dispatchLog(
              participant.identity + ' added track: ' + track.kind
            );
            let previewContainer = document.getElementById('remoteTrack');
            VueThis.attachTracks([track], previewContainer);
          });

          // When a Participant removes a Track, detach it from the DOM.
          room.on('trackRemoved', function(track, participant) {
            VueThis.dispatchLog(
              participant.identity + ' removed track: ' + track.kind
            );
            VueThis.detachTracks([track]);
          });

          // When a Participant leaves the Room, detach its Tracks.
          room.on('participantDisconnected', function(participant) {
            VueThis.dispatchLog(
              "Participant '" + participant.identity + "' left the room"
            );
            VueThis.detachParticipantTracks(participant);
          });

          // if local preview is not active, create it
          if (!VueThis.localTrack) {
            createLocalVideoTrack().then((track) => {
              let localMediaContainer = document.getElementById('localTrack');

              localMediaContainer.appendChild(track.attach());
              VueThis.localTrack = true;
            });
          }
        });
      });
    },
  },
};
</script>

<style>
.vidocontainer {
  flex: 1;
  /* border: 1px solid rgb(66, 218, 145); */
}
#localTrack video {
  display: inline-block;
  position: relative;
  padding: 0px;
  left: 65px;
  width: 750px;
  background-repeat: no-repeat;
  overflow: hidden;
  border-radius: 50%;
  border: #42da91 solid 10px;
}
.log {
  padding: 4px;
  color: dodgerblue;
  text-decoration: none;
  font-family: Arial, Helvetica, sans-serif;
  outline-color: #42da91;
  color: #fff;
  top: -70px;
}
.spacing {
  padding: 20px;
  width: 100%;
}
.roomTitle {
  padding: 20px;
  margin: 30px;
  color: dodgerblue;
  text-decoration: none;
  font-family: Arial, Helvetica, sans-serif;
  background: rgba(31, 42, 58, 0);
  outline-color: #42da91;
  color: #fff;
  top: -70px;
}
</style>

<style scoped>
.spaceVisual {
  height: 20px;
}

.user-speach {
  position: absolute;
  bottom: 700px;
  font-size: 20px;
  left: 55%;
  color: #fff;
}

.card {
  text-decoration: none;
  font-family: Arial, Helvetica, sans-serif;
  background: rgba(48, 64, 87, 0);
  outline-color: #42da91;
  color: #fff;
  border: 1px solid transparent;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.5), 0 6px 6px rgba(0, 0, 0, 0.6);
  top: -70px;
}

.card2 {
  text-decoration: none;
  font-family: Arial, Helvetica, sans-serif;
  background: rgba(31, 42, 58, 0.2);
  outline-color: #42da91;
  color: #fff;
  text-align: center;
  margin: 30px;
}

.circular--landscape {
  display: inline-block;
  position: relative;
  width: 200px;
  height: 200px;
  overflow: hidden;
  border-radius: 50%;
}
.circular--landscape img {
  width: auto;
  height: 100%;
  margin-left: -50px;
}
.db-content {
  background: #304057;
  background-size: 400% 400%;
  padding: 20px;
  min-height: 100vh;
  -webkit-animation: gradient 25s ease infinite;
  -animation: gradient 25s ease infinite;
}

@-webkit-keyframes gradient {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}

@keyframes gradient {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
  height: 150%;
}

.animation {
  position: absolute;
  bottom: -50px;
  font-size: 15px;
  min-height: 0px;
  left: -150px;
  right: 0px;
  border-radius: 10px;
  color: #fff;
}

.card-animate {
  animation-name: slideleft;
  /* position: relative;
  position-fromtop: 100px; */
  animation-duration: 10s;
  transition: opacity 1s Elastic.easeIn;
}
.card-animate-out {
  animation-name: slideright;
  /* position: relative;
  position-fromtop: 100px; */
  animation-duration: 10s;
  transition: opacity 1s Elastic.easeOut;
}

.card-animate-2 {
  animation-name: slideright;
  /* position: relative;
  position-fromtop: 100px; */
  animation-duration: 10s;
  transition: opacity 1s Elastic.easeIn;
}
.card-animate-2-out {
  animation-name: slideleft;
  /* position: relative;
  position-fromtop: 100px; */
  animation-duration: 10s;
  transition: opacity 1s Elastic.easeOut;
}

/* Standard syntax */
@keyframes slideleft {
  0% {
    left: -800px;
    top: -40px;
    opacity: 0;
  }
  100% {
    left: 92px;
    top: -40px;
    opacity: 1;
  }
}
/* Standard syntax */
@keyframes slideright {
  0% {
    left: 800px;
    top: 0px;
  }
  100% {
    left: 0px;
    top: 0px;
  }
}
@keyframes slidetop {
  0% {
    bottom: -1000px;
    top: 0px;
  }
  100% {
    bottom: 10px;
    top: 0px;
  }
}
@keyframes slidebottom {
  0% {
    bottom: 1000px;
    top: 0px;
  }
  100% {
    bottom: 10px;
    top: 0px;
  }
}
</style>
